// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Community-tabs-wrapper[data-v-bdeaa2c4]{width:100%;border-bottom:1px solid #000;margin-bottom:15px}.Community-tabs-wrapper h2[data-v-bdeaa2c4]{display:inline-block;padding:10px 20px;cursor:pointer;margin:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
